import { TYPE_TITLE_IMAGE } from '../../../constants/constant';
import { useIsMobile } from '../../../hooks/useIsMobile';
import './style.css';

type TitleImageProps = {
    title?: JSX.Element | string;
    subtitle?: JSX.Element | string;
    imagePath?: string;
    imageAlt?: string;
    inverted?: boolean;
    type?: keyof typeof TYPE_TITLE_IMAGE
};

const TitleImage = ({
    title = <></>,
    subtitle = <></>,
    imagePath = "",
    imageAlt = '',
    inverted,
    type = TYPE_TITLE_IMAGE.DEFAULT,
}: TitleImageProps) => {

    const isMobile = useIsMobile()

    return (
        <>
            <div className={type === TYPE_TITLE_IMAGE.DEFAULT ? "title-image-container" : "title-image-container-alt"}>
                {!inverted && !isMobile ?
                    <div className={type === TYPE_TITLE_IMAGE.DEFAULT ? 'title-image-content-image' : 'title-image-content-image-alt'}>
                        <img src={imagePath} alt={imageAlt ? imageAlt : 'Title Image'} />
                    </div>
                    : null}
                {!isMobile ?
                    <div className={inverted ? 'title-image-content-text-inverted' : 'title-image-content-text'}>
                        <h2 className='title-image-text-title'>{title}</h2>
                        <p>{subtitle}</p>
                    </div>
                    : null}
                {inverted || isMobile ?
                    <div className={type === TYPE_TITLE_IMAGE.DEFAULT ? 'title-image-content-image' : 'title-image-content-image-alt'}>
                        <img src={imagePath} alt={imageAlt ? imageAlt : 'Title Image'} />
                    </div>
                    : null}
            </div>
            {isMobile ?
                <div className={'title-image-content-text-mobile'}>
                    <h2 className='title-image-text-title'>{title}</h2>
                    <p>{subtitle}</p>
                </div>
                : null}
        </>
    );
};

export default TitleImage;
